<div class="row col-12 p-0 m-0 main-page-section ">

  <div class="col-12 p-0 employee-section">

    <div class="col-height">

      <div>

        <div class="breadcrumbs-section pl-2 ml-5">
          <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
          <img src="../../assets/images/seperator.png">
          <span class="prev-page pr-2 pl-2 prev" routerLink="/bulk-invite-approval">Invitation Approval</span>
          <img src="../../assets/images/seperator.png">
          <span class="prev-page pr-2 pl-2 prev" *ngIf="fromHistory"
            routerLink="/bulk-invite-approval/history">History</span>
          <img *ngIf="fromHistory" src="../../assets/images/seperator.png">
          <span class="curr-page pl-2 breadcrumbs-section-font current">Request Details</span>
        </div>

        <div class="history-layout" *ngIf="isLoaded">

          <div class="row">
            <div class="col-12">
              <h1>Request Details</h1>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <h2 class="mt-3">Inviter Details</h2>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-4">
              <p class="title">Full Name</p>
              <p class="result">{{data?.parkUser?.userName|titlecase}}</p>
            </div>
            <div class="col-4">
              <p class="title">Mobile Number</p>
              <p class="result">{{data?.parkUser?.phoneNumber}}</p>
            </div>
            <div class="col-4">
              <p class="title">Email ID</p>
              <p class="result">{{data?.parkUser?.emailId}}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <h2 class="mt-3">Meeting Details</h2>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-3">
              <p class="title">Start Date & Time</p>
              <p class="result">{{formatDate(data?.mstart,'date')}}, {{formatDate(data?.mstart,'time')}}</p>
            </div>
            <!--<div class="col-2">
              <p class="title">Time</p>
              <p class="result">{{formatDate(data?.mstart,'time')}}</p>
            </div>-->
             <div class="col-3">
              <p class="title">End Date & Time</p>
              <p class="result">{{formatDate(data?.mend,'date')}}, {{formatDate(data?.mend,'time')}}</p>
            </div>
            <!--<div class="col-2">
              <p class="title">Time</p>
              <p class="result">{{formatDate(data?.mend,'time')}}</p>
            </div>-->
            <div class="col-3">
              <p class="title">Building Name</p>
              <p class="result">{{data?.buildingName|titlecase}}</p>
            </div>
            <div class="col-3">
              <p class="title">Floor</p>
              <p class="result">{{data?.floor}}</p>
            </div>
            <div class="col-2"></div>
          </div>

          <div class="row mt-2" *ngIf="data?.description!==''&&data?.description!==null">
            <div class="col-12">
              <p class="title">Additional Remark</p>
              <p class="result" style="word-break: break-all;">{{data?.description}}</p>
            </div>
          </div>


          <div class="row" *ngIf="data?.isApproved==true">
            <div class="col-12">
              <p class="green-text" *ngIf="data?.approvedByAdminName==null">Approved on
                {{formatDate(data?.approvalDate,'date')}}</p>
              <p class="green-text" *ngIf="data?.approvedByAdminName!=null">Approved by {{data?.approvedByAdminName}} on
                {{formatDate(data?.approvalDate,'date')}}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-2 title">
              {{data?.t0600Vmsguests.length}} Guests
            </div>
            <div class="col-6"></div>
            <div class="col-4 text-right title">
              Request Sent on {{formatDate(data?.createdDate,'date')}}
            </div>
          </div>


          <div>

            <table class="table table-borderless table-striped table-curved mt-4" id="pdfTable" #pdfTable>
              <thead>
                <tr>

                  <th>Sr.No</th>
                  <th>Guest Name</th>
                  <th>Email Id</th>
                  <th>Contact Number</th>
                  <th></th>

                  <th></th>
                </tr>
              </thead>
              <tbody>

                <tr *ngFor="let tr of data?.t0600Vmsguests;let i=index">
                  <td>{{i+1}}</td>
                  <td>{{tr?.fullName|titlecase}}</td>
                  <td>{{tr?.email}}</td>
                  <td>+91 {{tr?.mobile}}</td>
                  <td></td>
                  <td></td>
                </tr>


              </tbody>
            </table>

          </div>

        </div>


        <div *ngIf="isLoaded">
          <div class="footer-layout" *ngIf="data?.isApproved==null&&!pastRecord">
            <button class="button-cancel" (click)="openModal('false')" *ngIf="vmsApprove">Reject</button>
            <button class="button-resend" (click)="openModal('true')" *ngIf="vmsApprove">Approve</button>
          </div>
        </div>


        <ng-template #contentActivation let-modal class="text-center">
          <div class="modal-height">
            <div class="modal-body">
              <div class="">
                <div class="text pt-3 pb-3">Are you sure, you want to {{statusText}} invite?</div>
                <div class="popup-line"></div>
              </div>
            </div>
            <div class="submit col-12 d-flex justify-content-end ">
              <div class="pr-3">
                <button type="button " (click)="modal.close('Save click')" class="cancel-button pt-3"><span
                    class="cancel">Cancel</span></button>
              </div>
              <button type="button " class="add-button" (click)="approve();modal.close('Save click')"><span
                  class="add">{{statusText}}</span></button>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
